(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sp-christmas"] && !Shopify.designMode) return;
  try {
    
(function(){
  function update(){
    const p=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const v=Object.fromEntries(p.map(x=>[x.type,x.value]));
    const today=Date.UTC(Number(v.year),Number(v.month)-1,Number(v.day));
    const target=Date.UTC(Number(v.year),11,24);
    const days=Math.max(0,Math.round((target-today)/86400000));
    document.querySelectorAll('.sp52-xmas').forEach(root=>{
      if(Number(v.month)<9||today>target){root.hidden=true;return;}
      const box=root.querySelector('[data-sp52-count]'),number=root.querySelector('[data-sp52-days]'),label=root.querySelector('[data-sp52-label]');
      if(!box||!number||!label)return;
      number.textContent=days===0?'':String(days);
      label.textContent=days===0?label.dataset.today:days===1?label.dataset.one:label.dataset.many;
      box.firstElementChild.hidden=days===0;
      box.hidden=false;
    });
  }
  update();
  setInterval(update,60000);
  document.addEventListener('shopify:section:load',update);
})();

  } catch(e) { console.error(e); }
})();
})();
